import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export const useFaultRepositoryInfo = function () {
    return useQuery(`fault-repository-info`, () => new Client().alert_GetFaultRepositoryEntries(), {
        refetchOnWindowFocus: false,
        staleTime: 180000
    })
};